import UserDisplayName from "./UserDisplayName";

export default {
  DisplayName: UserDisplayName,
};
